// src/services/pageActionScanner/buildActionCode.ts
// Build code định danh duy nhất cho 1 button/input trên trang, theo quy tắc đã chốt:
// mọi ký tự '/', '-', ':' trong UrlPage + code khai báo trên phần tử đều đổi thành '_'.

const normalizeActionCodeToken = (value: string): string =>
  value.trim().replace(/[/\-:]+/g, '_').replace(/^_+|_+$/g, '');

export const buildPageActionCode = (urlPage: string, elementCode: string): string => {
  const pagePart = normalizeActionCodeToken(urlPage);
  const elementPart = normalizeActionCodeToken(elementCode);
  return `${pagePart}_${elementPart}`;
};
